import { IButtonStyles, concatStyleSets, FontWeights } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../common/styles/common.styles';

export const getAppButtonStyles = (customStyles?: Partial<IButtonStyles>): IButtonStyles => {
  const defaultStyles: Partial<IButtonStyles> = {
    rootHovered: {
      backgroundColor: AppLayoutSettings.getAppColorContainer().primaryWidgetColorOnHover.value
    },
    rootPressed: {
      backgroundColor: AppLayoutSettings.getAppColorContainer().primaryWidgetColorOnHover.value
    },
    root: {
      backgroundColor: AppLayoutSettings.getAppColorContainer().primaryWidgetColor.value,
      color: AppLayoutSettings.getAppColorContainer().primaryWidgetLabelColor.value,
      borderRadius: '2px',
      height: '26px',
      whiteSpace: 'nowrap',
      marginBottom: '8px'
    },
    label: {
      fontSize: AppLayoutSettings.AppFontSize.mediumFontSizePx,
      fontWeight: FontWeights.semibold,
      textAlign: 'center'
    }
  };

  return concatStyleSets(defaultStyles, customStyles);
}

export const getSecondaryButtonOverrideStyles = (): Partial<IButtonStyles> => {
  return {
    rootHovered: {
      backgroundColor: AppLayoutSettings.getAppColorContainer().primaryWidgetColorOnHover.value,
      outlineColor: AppLayoutSettings.getAppColorContainer().secondaryWidgetBorderColor.value,
      border: `1px solid ${ AppLayoutSettings.getAppColorContainer().secondaryWidgetBorderColor.value}`,
    },
    rootPressed: {
      backgroundColor: AppLayoutSettings.getAppColorContainer().primaryWidgetColorOnHover.value,
    },
    labelHovered: {
      color: AppLayoutSettings.getAppColorContainer().primaryWidgetLabelColor.value
    },
    root: {
      backgroundColor:  AppLayoutSettings.getAppColorContainer().secondaryWidgetColor.value,
      color: AppLayoutSettings.getAppColorContainer().mediumLabelColor.value,
      border: `1px solid ${ AppLayoutSettings.getAppColorContainer().secondaryWidgetBorderColor.value}`,
      selectors: {
        [`:focus`]: {
          outline: '1px solid',
          outlineColor: AppLayoutSettings.getAppColorContainer().keyboardFocusColor.value
        }
      }
    }
  };
};

export const getSecondaryButtonStyles = (): Partial<IButtonStyles> => {
  return {
    root: {
      backgroundColor: 'transparent',
      color: AppLayoutSettings.getAppColorContainer().wordBlue.value,
      border: "none",
      background: "none",
      borderRadius: "0px",
      outline: 'none',
      borderWidth: '0px !important',
      selectors: {
        [`:focus, :hover, :active`]: {
          background: 'transparent !important',
          border: '0px !important',
          outline: 'none !important',
          borderRadius: '0px !important',
          borderWidth: '0px !important'
        }
      }
    },
    label: {
      color: AppLayoutSettings.getAppColorContainer().wordBlue.value
    }
  };
};
